import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="w-24 h-1 bg-luxury-gold mb-8"></div>
        <h1 className="text-5xl font-bold text-luxury-navy mb-8 luxury-heading">
          About Timberlake Flooring
        </h1>
        <div className="prose prose-lg">
          <p className="text-gray-600 text-lg leading-relaxed mb-6">
            Welcome to Timberlake Flooring - where premium craftsmanship meets unmatched value. As a leading flooring provider across the Greater Vancouver area, we proudly serve clients throughout British Columbia, including the Lower Mainland, Metro Vancouver, Tri-Cities, Fraser Valley, the Interior, and Vancouver Island. Wherever you are in B.C., Timberlake Flooring delivers exceptional quality, refined style, and a commitment to beat any comparable pricing, ensuring you receive the finest flooring solutions without compromise.
          </p>
          <p className="text-gray-600 text-lg leading-relaxed mb-6">
            Through our trusted industry partnerships, we bring you access to exceptional flooring products that emphasize style, durability, and comfort. Our extensive product portfolio includes premium collections from leading manufacturers, offering water-resistant laminate and engineered hardwood flooring.
          </p>
          <p className="text-gray-600 text-lg leading-relaxed mb-6">
            Whether you're renovating your home, upgrading a commercial space, or starting a new construction project, we're here to help you find the perfect flooring solution that meets your aesthetic preferences and functional requirements.
          </p>
          <div className="bg-gradient-to-br from-luxury-gold/10 to-luxury-gold/5 border-l-4 border-luxury-gold p-6 my-8">
            <h2 className="text-2xl font-bold text-luxury-navy mb-4 luxury-heading">Our Mission</h2>
            <p className="text-luxury-slate">
              To provide exceptional flooring products and services that transform spaces while delivering outstanding value and customer satisfaction.
            </p>
          </div>
          <h2 className="text-3xl font-bold text-luxury-navy mb-4 mt-12 luxury-heading">
            Why Choose Timberlake Flooring?
          </h2>
          <ul className="space-y-3 text-gray-600 text-lg">
            <li className="flex items-start">
              <span className="text-luxury-gold mr-3 text-2xl">•</span>
              <span>Authorized partner with leading flooring manufacturers</span>
            </li>
            <li className="flex items-start">
              <span className="text-luxury-gold mr-3 text-2xl">•</span>
              <span>Expert guidance on product selection and installation</span>
            </li>
            <li className="flex items-start">
              <span className="text-luxury-gold mr-3 text-2xl">•</span>
              <span>Local service with deep community roots</span>
            </li>
            <li className="flex items-start">
              <span className="text-luxury-gold mr-3 text-2xl">•</span>
              <span>Competitive pricing and exceptional value</span>
            </li>
            <li className="flex items-start">
              <span className="text-luxury-gold mr-3 text-2xl">•</span>
              <span>Comprehensive product warranties and support</span>
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
